import React from "react"
import classnames from "classnames"
import PropTypes from "prop-types"

import CustomerGreetings from "./CustomerGreetings"
import Menu from "../Menu"

import styles from "./styles.css"

const Main = ({ children, path }) => {
  return (
    <main className={mainClasses}>
      <div className={gridDefaultClasses}>
        <aside className={containerSideClasses}>
          <CustomerGreetings />
          <section className={styles.containerMenu}>
            <Menu currentPath={path} />
          </section>
        </aside>

        <div className={containerChildrenClasses}>{children}</div>
      </div>
    </main>
  )
}

const gridDefaultClasses = classnames(
  "Grid Grid-cell--center",
  styles.defaultSizeLayout,
  styles.maxHeight
)
const mainClasses = classnames(styles.content, styles.maxHeight)

const containerSideClasses = classnames(
  "Grid-cell u-size3of12",
  styles.containerSide
)
const containerChildrenClasses = classnames(
  "Grid-cell u-size9of12",
  styles.containerChildren
)

Main.propTypes = {
  children: PropTypes.node.isRequired,
  path: PropTypes.string
}

export default Main



// WEBPACK FOOTER //
// ./src/components/ModernLayout/Main/index.js